module.exports = __webpack_public_path__ + "static/img/upload-pbcs.62d04d22.jpg";